var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLogout = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.87493 19.9993H0.624978C0.28124 19.9993 0 19.7181 0 19.3743V0.624978C0 0.28124 0.28124 0 0.624978 0H1.87493C2.21867 0 2.49991 0.28124 2.49991 0.624978V19.3743C2.49991 19.7181 2.21867 19.9993 1.87493 19.9993ZM15.0984 0.734349L22.5982 8.23409C23.5721 9.20801 23.5721 10.7913 22.5982 11.7704L15.0984 19.2649C13.5256 20.8378 10.833 19.7181 10.833 17.4994V14.812H6.66643C5.28627 14.812 4.16652 13.6922 4.16652 12.3121V7.69765C4.16652 6.31749 5.28627 5.19773 6.66643 5.19773H10.833V2.49991C10.833 0.276032 13.5308 -0.833304 15.0984 0.734349ZM13.3329 2.49991V7.69244H6.66643V12.3069H13.3329V17.4994L20.8326 9.99965L13.3329 2.49991Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogout, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logout.8fb745df.svg";
export { ForwardRef as ReactComponent };